angular.module("ainapp")
    .service('VoucherValidationService', ['$q', '$window', '$http', "app.config", "localStorageService",
        function ($q, $window, $http, config, localStorageService) {

            this.validateVoucherHeader = function (data, vdes, cp) {
                var error = "";

                if (vdes.IsIntroLetterMandatory) {
                    if (data.IntroLetterDescription == "" || data.IntroLetterDescription == undefined || data.IntroLetterDescription == null) {
                        error = "Intro Letter Description Is Missing";
                    }
                }
                if (vdes.IsEndLetterMandatory) {
                    if (data.EndLetterDescription == "" || data.EndLetterDescription == undefined || data.EndLetterDescription == null) {
                        error = "End Letter Description Is Missing";
                    }
                }
                if (vdes.IsValidityMandatory) {
                    if (data.Validity == "" || data.Validity == undefined || data.Validity == null) {
                        error = "Validity Is Missing";
                    }
                }
                if (vdes.IsConcernPersonMandatory) {
                    if (data.ContactPerson == "" || data.ContactPerson == undefined || data.ContactPerson == null) {
                        error = "Contact Person Is Missing";
                    }
                }
                if (vdes.IsPlaceOfSupplyMandatory) {
                    if (data.SupplyPlace == "" || data.SupplyPlace == undefined || data.SupplyPlace == null) {
                        error = "Supply Place Is Missing";
                    }
                }
                if (vdes.IsShippingAddressMandatory) {
                    if (data.ShippingAddress == "" || data.ShippingAddress == undefined || data.ShippingAddress == null) {
                        error = "Shipping Address Is Missing";
                    }
                }
                if (vdes.IsSupplierBillNoMandatory) {
                    if (data.SupplierBillNo == "" || data.SupplierBillNo == undefined || data.SupplierBillNo == null) {
                        error = "Supplier Bill No Is Missing";
                    }
                }
                if (vdes.IsSupplierQtnNoMandatory) {
                    if (data.SupplierQtnNo == "" || data.SupplierQtnNo == undefined || data.SupplierQtnNo == null) {
                        error = "Supplier Qtn No Is Missing";
                    }
                }
                if (vdes.IsWeightMandatory) {
                    if (data.WeightDimension == "" || data.WeightDimension == undefined || data.WeightDimension == null) {
                        error = "Weight Dimension Is Missing";
                    }
                }
                if (vdes.IsNoOfPackagesMandatory) {
                    if (data.NoOfPackages == "" || data.NoOfPackages == undefined || data.NoOfPackages == null) {
                        error = "No Of Packages Is Missing";
                    }
                }
                if (vdes.IsTotalGrossWeightMandatory) {
                    if (data.TotalGrossWeight == "" || data.TotalGrossWeight == undefined || data.TotalGrossWeight == null) {
                        error = "Total Gross Weight Is Missing";
                    }
                }
                if (vdes.IsNetWeightMandatory) {
                    if (data.TotalNetWeight == "" || data.TotalNetWeight == undefined || data.TotalNetWeight == null) {
                        error = "Total Net Weight Is Missing";
                    }
                }
                if (vdes.IsEnquiryNoMandatory) {
                    if (data.EnquiryNo == "" || data.EnquiryNo == undefined || data.EnquiryNo == null) {
                        error = "Enquiry No Is Missing";
                    }
                }
                if (vdes.IsOrderNoMandatory) {
                    if (data.OrderNo == "" || data.OrderNo == undefined || data.OrderNo == null) {
                        error = "Order No Is Missing";
                    }
                }
                if (vdes.IsWarrentyPeriodMandatory) {
                    if (data.WarrantyPeriod == "" || data.WarrantyPeriod == undefined || data.WarrantyPeriod == null) {
                        error = "Warranty Period Is Missing";
                    }
                }
                if (vdes.IsDeliveryPeriodMandatory) {
                    if (data.DeliveryPeriod == "" || data.DeliveryPeriod == undefined || data.DeliveryPeriod == null) {
                        error = "Delivery Period Is Missing";
                    }
                }
                if (vdes.IsDeliveryBasisMandatory) {
                    if (data.DeliveryBasis == "" || data.DeliveryBasis == undefined || data.DeliveryBasis == null) {
                        error = "Delivery Basis Is Missing";
                    }
                }
                if (vdes.IsPaymentTermsMandatory) {
                    if (data.PaymentTerms == "" || data.PaymentTerms == undefined || data.PaymentTerms == null) {
                        error = "Payment Terms Is Missing";
                    }
                }
                if (vdes.IsDeliveryDateMandatory) {
                    if (data.DeliveryDate == "" || data.DeliveryDate == undefined || data.DeliveryDate == null) {
                        error = "Delivery Date Is Missing";
                    }
                }
                if (vdes.IsDeliveryTimeMandatory) {
                    if (data.DeliveryTime == "" || data.DeliveryTime == undefined || data.DeliveryTime == null) {
                        error = "Delivery Time Is Missing";
                    }
                }
                if (vdes.IsReturnDateMandatory) {
                    if (data.ReturnDate == "" || data.ReturnDate == undefined || data.ReturnDate == null) {
                        error = "Return Date Is Missing";
                    }
                }
                if (vdes.IsReturnTimeMandatory) {
                    if (data.ReturnTime == "" || data.ReturnTime == undefined || data.ReturnTime == null) {
                        error = "Return Time Is Missing";
                    }
                }
                if (vdes.IsSupplierBillDateMandatory) {
                    if (data.SupplierBillDate == "" || data.SupplierBillDate == undefined || data.SupplierBillDate == null) {
                        error = "Supplier Bill Date Is Missing";
                    }
                }
                if (vdes.IsSalesEmployeeMandatory) {
                    if (data.EmployeeId == "" || data.EmployeeId == undefined || data.EmployeeId == null) {
                        error = "Employee Is Missing";
                    }
                }
                if (vdes.IsCustomerPOMandatory) {
                    if (data.CustomerPONo == "" || data.CustomerPONo == undefined || data.CustomerPONo == null) {
                        error = "Customer PO No Is Missing";
                    }
                }
                if (vdes.IsSupplierPOMandatory) {
                    if (data.SupplierPONO == "" || data.SupplierPONO == undefined || data.SupplierPONO == null) {
                        error = "Supplier PO NO Is Missing";
                    }
                }

                if (vdes.IsField1Mandatory) {
                    if (data.Field1 == "" || data.Field1 == undefined || data.Field1 == null) {
                        error = vdes.Field1 + " Is Missing";
                    }
                }
                if (vdes.IsField2Mandatory) {
                    if (data.Field2 == "" || data.Field2 == undefined || data.Field2 == null) {
                        error = vdes.Field2 + " Is Missing";
                    }
                }
                if (vdes.IsField3Mandatory) {
                    if (data.Field3 == "" || data.Field3 == undefined || data.Field3 == null) {
                        error = vdes.Field3 + " Is Missing";
                    }
                }
                if (vdes.IsField4Mandatory) {
                    if (data.Field4 == "" || data.Field4 == undefined || data.Field4 == null) {
                        error = vdes.Field4 + " Is Missing";
                    }
                }
                if (vdes.IsField5Mandatory) {
                    if (data.Field5 == "" || data.Field5 == undefined || data.Field5 == null) {
                        error = vdes.Field5 + " Is Missing";
                    }
                }
                if (vdes.IsField6Mandatory) {
                    if (data.Field6 == "" || data.Field6 == undefined || data.Field6 == null) {
                        error = vdes.Field6 + " Is Missing";
                    }
                }
                if (vdes.IsField7Mandatory) {
                    if (data.Field7 == "" || data.Field7 == undefined || data.Field7 == null) {
                        error = vdes.Field7 + " Is Missing";
                    }
                }
                if (vdes.IsField8Mandatory) {
                    if (data.Field8 == "" || data.Field8 == undefined || data.Field8 == null) {
                        error = vdes.Field8 + " Is Missing";
                    }
                }
                if (vdes.IsField9Mandatory) {
                    if (data.Field9 == "" || data.Field9 == undefined || data.Field9 == null) {
                        error = vdes.Field9 + " Is Missing";
                    }
                }
                if (vdes.IsField10Mandatory) {
                    if (data.Field10 == "" || data.Field10 == undefined || data.Field10 == null) {
                        error = vdes.Field10 + " Is Missing";
                    }
                }
                if (vdes.IsField11Mandatory) {
                    if (data.Field11 == "" || data.Field11 == undefined || data.Field11 == null) {
                        error = vdes.Field11 + " Is Missing";
                    }
                }
                if (vdes.IsField12Mandatory) {
                    if (data.Field12 == "" || data.Field12 == undefined || data.Field12 == null) {
                        error = vdes.Field12 + " Is Missing";
                    }
                }
                if (vdes.IsField13Mandatory) {
                    if (data.Field13 == "" || data.Field13 == undefined || data.Field13 == null) {
                        error = vdes.Field13 + " Is Missing";
                    }
                }
                if (vdes.IsField14Mandatory) {
                    if (data.Field14 == "" || data.Field14 == undefined || data.Field14 == null) {
                        error = vdes.Field14 + " Is Missing";
                    }
                }
                if (vdes.IsField15Mandatory) {
                    if (data.Field15 == "" || data.Field15 == undefined || data.Field15 == null) {
                        error = vdes.Field15 + " Is Missing";
                    }
                }
                if (vdes.IsField16Mandatory) {
                    if (data.Field16 == "" || data.Field16 == undefined || data.Field16 == null) {
                        error = vdes.Field16 + " Is Missing";
                    }
                }
                if (vdes.IsField17Mandatory) {
                    if (data.Field17 == "" || data.Field17 == undefined || data.Field17 == null) {
                        error = vdes.Field17 + " Is Missing";
                    }
                }
                if (vdes.IsField18Mandatory) {
                    if (data.Field18 == "" || data.Field18 == undefined || data.Field18 == null) {
                        error = vdes.Field18 + " Is Missing";
                    }
                }
                if (vdes.IsField19Mandatory) {
                    if (data.Field19 == "" || data.Field19 == undefined || data.Field19 == null) {
                        error = vdes.Field19 + " Is Missing";
                    }
                }
                if (vdes.IsField20Mandatory) {
                    if (data.Field20 == "" || data.Field20 == undefined || data.Field20 == null) {
                        error = vdes.Field20 + " Is Missing";
                    }
                }
                if (vdes.IsField21Mandatory) {
                    if (data.Field21 == "" || data.Field21 == undefined || data.Field21 == null) {
                        error = vdes.Field21 + " Is Missing";
                    }
                }
                if (vdes.IsField22Mandatory) {
                    if (data.Field22 == "" || data.Field22 == undefined || data.Field22 == null) {
                        error = vdes.Field22 + " Is Missing";
                    }
                }
                if (vdes.IsField23Mandatory) {
                    if (data.Field23 == "" || data.Field23 == undefined || data.Field23 == null) {
                        error = vdes.Field23 + " Is Missing";
                    }
                }
                if (vdes.IsField24Mandatory) {
                    if (data.Field24 == "" || data.Field24 == undefined || data.Field24 == null) {
                        error = vdes.Field24 + " Is Missing";
                    }
                }
                if (vdes.IsField25Mandatory) {
                    if (data.Field25 == "" || data.Field25 == undefined || data.Field25 == null) {
                        error = vdes.Field25 + " Is Missing";
                    }
                }
                if (vdes.IsField26Mandatory) {
                    if (data.Field26 == "" || data.Field26 == undefined || data.Field26 == null) {
                        error = vdes.Field26 + " Is Missing";
                    }
                }
                if (vdes.IsField27Mandatory) {
                    if (data.Field27 == "" || data.Field27 == undefined || data.Field27 == null) {
                        error = vdes.Field27 + " Is Missing";
                    }
                }
                if (vdes.IsField28Mandatory) {
                    if (data.Field28 == "" || data.Field28 == undefined || data.Field28 == null) {
                        error = vdes.Field28 + " Is Missing";
                    }
                }
                if (vdes.IsField29Mandatory) {
                    if (data.Field29 == "" || data.Field29 == undefined || data.Field29 == null) {
                        error = vdes.Field29 + " Is Missing";
                    }
                }
                if (vdes.IsField30Mandatory) {
                    if (data.Field30 == "" || data.Field30 == undefined || data.Field30 == null) {
                        error = vdes.Field30 + " Is Missing";
                    }
                }
                if (vdes.IsMaster1Mandatory) {
                    if (!data.Master1Id > 0) {
                        error = cp.Master1Name + " Is Missing";
                    }
                }
                if (vdes.IsMaster2Mandatory) {
                    if (!data.Master2Id > 0) {
                        error = cp.Master2Name + " Is Missing";
                    }
                }
                if (vdes.IsMaster3Mandatory) {
                    if (!data.Master3Id > 0) {
                        error = cp.Master3Name + " Is Missing";
                    }
                }
                if (vdes.IsMaster4Mandatory) {
                    if (!data.Master4Id > 0) {
                        error = cp.Master4Name + " Is Missing";
                    }
                }
                if (vdes.IsMaster5Mandatory) {
                    if (!data.Master5Id > 0) {
                        error = cp.Master5Name + " Is Missing";
                    }
                }


                return error;
            };


            this.validateVoucherBody = function (data, vdes, cp, isRemarksSmall) {

                var error = "";

                if (vdes.IsDDescriptionMandatory) {
                    if (isRemarksSmall) {
                        if (data.remarks == "" || data.remarks == undefined || data.remarks == null) {
                            error = "Remarks Is Missing";
                        }
                    } else {
                        if (data.Remarks == "" || data.Remarks == undefined || data.Remarks == null) {
                            error = "Remarks Is Missing";
                        }
                    }

                }
                if (vdes.IsDUnitMandatory) {
                    if (!data.UnitId > 0) {
                        error = "Unit Is Missing";
                    }
                }
                if (vdes.IsDVatMandatory) {
                    if (!data.VATId > 0) {
                        error = "VAT Is Missing";
                    }
                }
                if (vdes.IsDVatTypeMandatory) {
                    if (data.VatType == "" || data.VatType == undefined || data.VatType == null) {
                        error = "Vat Type Is Missing";
                    }
                }
                if (vdes.IsDQuantityMandatory) {
                    if (!data.Quantity > 0) {
                        error = "Quantity Is Missing";
                    }
                }
                if (vdes.IsDActQtyMandatory) {
                    if (!data.ActualQty > 0) {
                        error = "Actual Qty Is Missing";
                    }
                }
                if (vdes.IsDLinkPerMandatory) {
                    if (!data.LinkPer > 0) {
                        error = "Link % Is Missing";
                    }
                }
                if (vdes.IsDUnitPriceMandatory) {
                    if (!data.UnitPrice > 0) {
                        error = "Unit Price Is Missing";
                    }
                }
                if (vdes.IsDCostMandatory) {
                    if (!data.Cost > 0) {
                        error = "Cost Is Missing";
                    }
                }
                if (vdes.IsDGrossMandatory) {
                    if (!data.Total > 0) {
                        error = "Total Is Missing";
                    }
                }
                if (vdes.IsDDiscountMandatory) {
                    if (!data.Discount > 0) {
                        error = "Discount Is Missing";
                    }
                }
                if (vdes.IsDTaxableMandatory) {
                    if (!data.TaxableAmount > 0) {
                        error = "Taxable Amount Is Missing";
                    }
                }
                if (vdes.IsDTotalVatMandatory) {
                    if (!data.TaxValue > 0) {
                        error = "Tax Value Is Missing";
                    }
                }
                if (vdes.IsDRoundVatMandatory) {
                    if (!data.RoundOfVat > 0) {
                        error = "Round Of Vat Is Missing";
                    }
                }
                if (vdes.IsDTotalMandatory) {
                    if (!data.InventoryValue > 0) {
                        error = "Total Is Missing";
                    }
                }
                if (vdes.IsDNetWeightMandatory) {
                    if (!data.NetWeight > 0) {
                        error = "Net Weight  Is Missing";
                    }
                }
                if (vdes.IsDGrossWeightMandatory) {
                    if (!data.GrossWeight > 0) {
                        error = "Gross Weight  Is Missing";
                    }
                }
                if (vdes.IsDTotalNetWeightMandatory) {
                    if (!data.TotalNetWeight > 0) {
                        error = "Total Net Weight  Is Missing";
                    }
                }
                if (vdes.IsDTotalGrossWeightMandatory) {
                    if (!data.TotalGrossWeight > 0) {
                        error = "Total Gross Weight  Is Missing";
                    }
                }
                if (vdes.IsDFocQuantityMandatory) {
                    if (!data.FocQuantity > 0) {
                        error = "Foc Quantity  Is Missing";
                    }
                }

                if (vdes.IsCountryMandatory) {
                    if (!data.CountryId > 0) {
                        error = "Country Is Missing";
                    }
                }
                if (vdes.IsWareHouseMandatory) {
                    if (!data.WarehouseId > 0) {
                        error = "Warehouse Is Missing";
                    }
                }
                if (vdes.IsBrandMandatory) {
                    if (!data.BrandId > 0) {
                        error = "Brand Is Missing";
                    }
                }
                if (vdes.IsDiscountTypeMandatory) {
                    if (data.DiscountType == "" || data.DiscountType == undefined || data.DiscountType == null) {
                        error = "Discount Type Is Missing";
                    }
                }
                if (vdes.IsDiscountValueMandatory) {
                    if (!data.DiscountValue > 0) {
                        error = "Discount Value Is Missing";
                    }
                }
                if (vdes.IsManufMandatory) {
                    if (data.Manufacturing == "" || data.Manufacturing == undefined || data.Manufacturing == null) {
                        error = "Manuf Is Missing";
                    }
                }
                if (vdes.IsYrRefMandatory) {
                    if (data.YRRefNo == "" || data.YRRefNo == undefined || data.YRRefNo == null) {
                        error = "YR Ref No Is Missing";
                    }
                }
                if (vdes.IsStockMandatory) {
                    if (data.Stock == "" || data.Stock == undefined || data.Stock == null) {
                        error = "Stock Is Missing";
                    }
                }
                if (vdes.IsBonusMandatory) {
                    if (!data.Bonus > 0) {
                        error = "Bonus Is Missing";
                    }
                }
                if (vdes.IsQCostMandatory) {
                    if (!data.QCost > 0) {
                        error = "Q Cost  Is Missing";
                    }
                }
                if (vdes.IsTCostMandatory) {
                    if (!data.TCost > 0) {
                        error = "T Cost  Is Missing";
                    }
                }
                if (vdes.IsFrieghtChargesMandatory) {
                    if (!data.FreightCharges > 0) {
                        error = "Freight Charges  Is Missing";
                    }
                }
                if (vdes.IsPackingChargesMandatory) {
                    if (!data.PackingCharges > 0) {
                        error = "Packing Charges  Is Missing";
                    }
                }
                if (vdes.IsOtherChargesMandatory) {
                    if (!data.OtherCharges > 0) {
                        error = "Other Charges  Is Missing";
                    }
                }
                if (vdes.IsClearingChargesMandatory) {
                    if (!data.ClearingCharges > 0) {
                        error = "Clearing Charges  Is Missing";
                    }
                }
                if (vdes.IsDutyChargesMandatory) {
                    if (!data.CustomDuty > 0) {
                        error = "Custom  Duty  Is Missing";
                    }
                }
                if (vdes.IsDeliveryChargesMandatory) {
                    if (!data.DeliveryCharges > 0) {
                        error = "Delivery Charges  Is Missing";
                    }
                }
                if (vdes.IsExtraChargesMandatory) {
                    if (!data.ExtraCharges > 0) {
                        error = "Extra Charges  Is Missing";
                    }
                }


                if (vdes.IsDField1Mandatory) {
                    if (data.Field1 == "" || data.Field1 == undefined || data.Field1 == null) {
                        error = vdes.DField1 + " Is Missing";
                    }
                }
                if (vdes.IsField2Mandatory) {
                    if (data.Field2 == "" || data.Field2 == undefined || data.Field2 == null) {
                        error = vdes.Field2 + " Is Missing";
                    }
                }
                if (vdes.IsDField3Mandatory) {
                    if (data.Field3 == "" || data.Field3 == undefined || data.Field3 == null) {
                        error = vdes.DField3 + " Is Missing";
                    }
                }
                if (vdes.IsDField4Mandatory) {
                    if (data.Field4 == "" || data.Field4 == undefined || data.Field4 == null) {
                        error = vdes.DField4 + " Is Missing";
                    }
                }
                if (vdes.IsDField5Mandatory) {
                    if (data.Field5 == "" || data.Field5 == undefined || data.Field5 == null) {
                        error = vdes.DField5 + " Is Missing";
                    }
                }
                if (vdes.IsDField6Mandatory) {
                    if (data.Field6 == "" || data.Field6 == undefined || data.Field6 == null) {
                        error = vdes.DField6 + " Is Missing";
                    }
                }
                if (vdes.IsDField7Mandatory) {
                    if (data.Field7 == "" || data.Field7 == undefined || data.Field7 == null) {
                        error = vdes.DField7 + " Is Missing";
                    }
                }
                if (vdes.IsDField8Mandatory) {
                    if (data.Field8 == "" || data.Field8 == undefined || data.Field8 == null) {
                        error = vdes.DField8 + " Is Missing";
                    }
                }
                if (vdes.IsDField9Mandatory) {
                    if (data.Field9 == "" || data.Field9 == undefined || data.Field9 == null) {
                        error = vdes.DField9 + " Is Missing";
                    }
                }
                if (vdes.IsField10Mandatory) {
                    if (data.Field10 == "" || data.Field10 == undefined || data.Field10 == null) {
                        error = vdes.Field10 + " Is Missing";
                    }
                }
                if (vdes.IsField11Mandatory) {
                    if (data.Field11 == "" || data.Field11 == undefined || data.Field11 == null) {
                        error = vdes.Field11 + " Is Missing";
                    }
                }
                if (vdes.IsDField12Mandatory) {
                    if (data.Field12 == "" || data.Field12 == undefined || data.Field12 == null) {
                        error = vdes.DField12 + " Is Missing";
                    }
                }
                if (vdes.IsDField13Mandatory) {
                    if (data.Field13 == "" || data.Field13 == undefined || data.Field13 == null) {
                        error = vdes.DField13 + " Is Missing";
                    }
                }
                if (vdes.IsDField14Mandatory) {
                    if (data.Field14 == "" || data.Field14 == undefined || data.Field14 == null) {
                        error = vdes.DField14 + " Is Missing";
                    }
                }
                if (vdes.IsDField15Mandatory) {
                    if (data.Field15 == "" || data.Field15 == undefined || data.Field15 == null) {
                        error = vdes.DField15 + " Is Missing";
                    }
                }
                if (vdes.IsDField16Mandatory) {
                    if (data.Field16 == "" || data.Field16 == undefined || data.Field16 == null) {
                        error = vdes.DField16 + " Is Missing";
                    }
                }
                if (vdes.IsDField17Mandatory) {
                    if (data.Field17 == "" || data.Field17 == undefined || data.Field17 == null) {
                        error = vdes.DField17 + " Is Missing";
                    }
                }
                if (vdes.IsDField18Mandatory) {
                    if (data.Field18 == "" || data.Field18 == undefined || data.Field18 == null) {
                        error = vdes.DField18 + " Is Missing";
                    }
                }
                if (vdes.IsDField19Mandatory) {
                    if (data.Field19 == "" || data.Field19 == undefined || data.Field19 == null) {
                        error = vdes.DField19 + " Is Missing";
                    }
                }
                if (vdes.IsDField20Mandatory) {
                    if (data.Field20 == "" || data.Field20 == undefined || data.Field20 == null) {
                        error = vdes.DField20 + " Is Missing";
                    }
                }
                if (vdes.IsDField21Mandatory) {
                    if (data.Field21 == "" || data.Field21 == undefined || data.Field21 == null) {
                        error = vdes.DField21 + " Is Missing";
                    }
                }
                if (vdes.IsField22Mandatory) {
                    if (data.Field22 == "" || data.Field22 == undefined || data.Field22 == null) {
                        error = vdes.Field22 + " Is Missing";
                    }
                }
                if (vdes.IsDField23Mandatory) {
                    if (data.Field23 == "" || data.Field23 == undefined || data.Field23 == null) {
                        error = vdes.DField23 + " Is Missing";
                    }
                }
                if (vdes.IsDField24Mandatory) {
                    if (data.Field24 == "" || data.Field24 == undefined || data.Field24 == null) {
                        error = vdes.DField24 + " Is Missing";
                    }
                }
                if (vdes.IsDField25Mandatory) {
                    if (data.Field25 == "" || data.Field25 == undefined || data.Field25 == null) {
                        error = vdes.DField25 + " Is Missing";
                    }
                }
                if (vdes.IsDField26Mandatory) {
                    if (data.Field26 == "" || data.Field26 == undefined || data.Field26 == null) {
                        error = vdes.DField26 + " Is Missing";
                    }
                }
                if (vdes.IsDField27Mandatory) {
                    if (data.Field27 == "" || data.Field27 == undefined || data.Field27 == null) {
                        error = vdes.DField27 + " Is Missing";
                    }
                }
                if (vdes.IsDField28Mandatory) {
                    if (data.Field28 == "" || data.Field28 == undefined || data.Field28 == null) {
                        error = vdes.DField28 + " Is Missing";
                    }
                }
                if (vdes.IsDField29Mandatory) {
                    if (data.Field29 == "" || data.Field29 == undefined || data.Field29 == null) {
                        error = vdes.DField29 + " Is Missing";
                    }
                }
                if (vdes.IsDField30Mandatory) {
                    if (data.Field30 == "" || data.Field30 == undefined || data.Field30 == null) {
                        error = vdes.DField30 + " Is Missing";
                    }
                }
                if (vdes.IsMaster6Mandatory) {
                    if (!data.Master6Id > 0) {
                        error = cp.Master6Name + " Is Missing";
                    }
                }
                if (vdes.IsMaster7Mandatory) {
                    if (!data.Master7Id > 0) {
                        error = cp.Master7Name + " Is Missing";
                    }
                }
                if (vdes.IsMaster8Mandatory) {
                    if (!data.Master8Id > 0) {
                        error = cp.Master8Name + " Is Missing";
                    }
                }

                return error;

            }


        }
    ])
